import { PCMS_AMDSM_REQUEST, PCMS_AMDSM_LOADING, PCMS_AMDSM_SUCCESS, PCMS_AMDSM_FAILURE,
         PCMS_SOT_REQUEST, PCMS_SOT_LOADING, PCMS_SOT_SUCCESS, PCMS_SOT_FAILURE,
         PCMS_CARE_ASSIST_REQUEST,
         PCMS_CARE_ASSIST_SUCCESS,
         PCMS_CARE_ASSIST_FAILURE,
         PCMS_CARE_ASSIST_LOADING,
         PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING,
         PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS,
         PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE,
         PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_REQUEST,
         PCMS_DETAILS_REQUEST,
         PCMS_DETAILS_SUCCESS,
         PCMS_DETAILS_FAILURE,
         PCMS_DETAILS_LOADING,
         PCMS_FILTER_DATA_REQUEST,
         PCMS_FILTER_DATA_SUCCESS,
         PCMS_FILTER_DATA_FAILURE,
         PCMS_FILTER_DATA_LOADING,
 } from "../../actionTypes";

// Alternative Medication Displays & Switches Made //

export const AMDSMDataRequest = (payload: any) => ({
  type: PCMS_AMDSM_REQUEST,
  payload,
});

export const AMDSMDDataSuccess = (payload: any) => ({
  type: PCMS_AMDSM_SUCCESS,
  payload,
});
export const AMDSMDDataError = (payload: any) => ({
  type: PCMS_AMDSM_FAILURE,
  payload,
});
export const AMDSMDDataLoading = (payload: any) => ({
  type: PCMS_AMDSM_LOADING,
  payload,
});

// Switches Over Time //

export const SOTDataRequest = (payload: any) => ({
    type: PCMS_SOT_REQUEST,
    payload,
  });
  
  export const SOTDataSuccess = (payload: any) => ({
    type: PCMS_SOT_SUCCESS,
    payload,
  });
  export const SOTDataError = (payload: any) => ({
    type: PCMS_SOT_FAILURE,
    payload,
  });
  export const SOTDataLoading = (payload: any) => ({
    type: PCMS_SOT_LOADING,
    payload,
  });

// Care Assist //
export const CareAssistDataRequest = (payload: any) => ({
  type: PCMS_CARE_ASSIST_REQUEST,
  payload,
});
export const CareAssistDataSuccess = (payload: any) => ({
  type: PCMS_CARE_ASSIST_SUCCESS,
  payload,
});
export const CareAssistDataError = (payload: any) => ({
  type: PCMS_CARE_ASSIST_FAILURE,
  payload,
});
export const CareAssistDataLoading = (payload: any) => ({
  type: PCMS_CARE_ASSIST_LOADING,
  payload,
});

// Care Assist Activation details//
export const CareAssistTinActivationsDetailsRequest = (payload: any) => ({
  type: PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_REQUEST,
  payload,
});
export const CareAssistTinActivationsDetailsSuccess = (payload: any) => ({
  type: PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS,
  payload,
});
export const CareAssistTinActivationsDetailsError = (payload: any) => ({
  type: PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE,
  payload,
});
export const CareAssistTinActivationsDetailsLoading = (payload: any) => ({
  type: PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING,
  payload,
});
// PCMS Table Details //
export const PCMSTableDataRequest = (payload: any) => ({
  type: PCMS_DETAILS_REQUEST,
  payload,
});
export const PCMSTableDataSuccess = (payload: any) => ({
  type: PCMS_DETAILS_SUCCESS,
  payload,
});
export const PCMSTableDataError = (payload: any) => ({
  type: PCMS_DETAILS_FAILURE,
  payload,
});
export const PCMSTableDataLoading = (payload: any) => ({
  type: PCMS_DETAILS_LOADING,
  payload,
});

// PCMS Filter Data //
export const pcmsFilterDataRequest = (payload: any) => ({
  type: PCMS_FILTER_DATA_REQUEST,
  payload,
});
export const pcmsFilterDataSuccess = (payload: any) => ({
  type: PCMS_FILTER_DATA_SUCCESS,
  payload,
});
export const pcmsFilterDataError = (payload: any) => ({
  type: PCMS_FILTER_DATA_FAILURE,
  payload,
});
export const pcmsFilterDataLoading = (payload: any) => ({
  type: PCMS_FILTER_DATA_LOADING,
  payload,
});